import { render } from "./ServicesDetailsPage.vue?vue&type=template&id=0f95c220"
import script from "./ServicesDetailsPage.vue?vue&type=script&lang=js"
export * from "./ServicesDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__